import { useEffect } from 'react'
import { useRouter } from 'next/router'

const Index = () => {
  const router = useRouter()

  useEffect(() => {
    // Redirect to default country
    router.replace('/id/')
  }, [])

  return null
}

export default Index
